import axios from "axios";
import Logger from "./Logger";
import { v4 as uuidv4 } from "uuid";
import CryptoJS from "crypto-js";
import Crypto from "./AesClient";

class apiClient {
  static async postWithoutToken(byUrl, byData) {
    return await this.postAes(byUrl, byData);
  }

  static async post(byUrl, byData) {
    const ReactId = uuidv4();
    const Token = JSON.parse(localStorage.getItem("auth"))?.Token;
    await this.logOfAction(ReactId, "apiClient(" + byUrl + ")", "Before", {
      token: Token,
      version: import.meta.env.VITE_VERSION,
    });

    try {
      const response = await this.postCore("application/json", byUrl, byData);
      await this.logOfAction(ReactId, "apiClient(" + byUrl + ")", "Completed", {
        token: Token,
        version: import.meta.env.VITE_VERSION,
      });

      return response;
    } catch (e) {
      await this.logOfAction(ReactId, "apiClient(" + byUrl + ")", "Error", {
        token: Token,
        version: import.meta.env.VITE_VERSION,
        status: e.response?.status,
      });

      return { status: e.response?.status, data: null };
    }
  }

  static async postAes(byUrl, byData) {
    const ReactId = uuidv4();
    const Token = JSON.parse(localStorage.getItem("auth"))?.Token;
    const ActionId = localStorage.getItem("backEndActionId");

    const TokenData = { ...byData, Token: Token, ActionId: ActionId };
    console.log(TokenData);
    console.log(byUrl);

    try {
      const EncryptData = await Crypto.AesEncrypt(TokenData);

      const response = await this.postCore("text/plain", byUrl, EncryptData);

      // await this.logOfAction(ReactId, "apiClient(" + byUrl + ")", "Completed", {
      //   token: Token,
      //   version: import.meta.env.VITE_VERSION,
      // });

      const DecryptData = await Crypto.AesDecrypt(response.data);

      return { status: response.status, data: DecryptData };
    } catch (e) {
      await this.logOfAction(ReactId, "apiClient(" + byUrl + ")", "Error", {
        token: Token,
        version: import.meta.env.VITE_VERSION,
        status: e.response?.status,
      });

      return { status: e.response?.status, data: null };
    }
  }

  static async postCore(byType, byUrl, byData) {
    const Token = JSON.parse(localStorage.getItem("auth"))?.Token;
    const instance = axios.create({
      baseURL: import.meta.env.VITE_API_ROOT_URL,
      headers: {
        "Content-Type": byType,
        Authorization: `${Token}`,
      },
    });

    const response = await instance.post(byUrl, byData);
    return response;
  }

  static async logOfActionWithoutId(byPageName, byActionName, byData) {
    const ReactId = uuidv4();
    this.logOfAction(ReactId, byPageName, byActionName, byData);
  }

  static async logOfActionEnterPage(byPageName, byActionName, byData) {
    const actiionId = localStorage.getItem("backEndActionId");

    this.logOfAction(actiionId, byPageName, byActionName, byData);
  }

  static async logOfAction(byReactId, byPageName, byActionName, byData) {
    try {
      const data = {
        Data: {
          ReactId: byReactId,
          IdentityName: byPageName,
          Action: byActionName,
          Payload: JSON.stringify(byData),
        },
      };
      // console.log(data);

      const EncryptData = await Crypto.AesEncrypt(data);

      await this.postCore(
        "text/plain",
        "api/logger/logofaction/security",
        EncryptData
      );
    } catch {}
  }
}

export default apiClient;
